import { render, staticRenderFns } from "./ListDropzone.vue?vue&type=template&id=17078e64&"
import script from "./ListDropzone.vue?vue&type=script&lang=ts&"
export * from "./ListDropzone.vue?vue&type=script&lang=ts&"
import style0 from "./ListDropzone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports